import React from 'react';
import img01 from '../../images/img01.jpg';
import '../../css/Home.css';
import TituloPagina from '../../js/Components/PageTitle';

const services = [
  {
    icon: '🦷',
    title: 'Ortodoncia',
    text: 'Brackets metálicos o estéticos para alinear tu sonrisa con diagnóstico y seguimiento profesional.',
  },
  {
    icon: '✨',
    title: 'Limpieza dental',
    text: 'Profilaxis, retiro de sarro y cuidado preventivo para mantener dientes y encías saludables.',
  },
  {
    icon: '😁',
    title: 'Estética dental',
    text: 'Opciones enfocadas en mejorar color, forma y armonía de tu sonrisa.',
  },
  {
    icon: '🛡️',
    title: 'Prevención',
    text: 'Revisiones, orientación y tratamientos tempranos para evitar problemas mayores.',
  },
  {
    icon: '👨‍👩‍👧',
    title: 'Atención familiar',
    text: 'Tratamientos para diferentes edades con trato claro, amable y cercano.',
  },
  {
    icon: '📋',
    title: 'Diagnóstico',
    text: 'Valoración clínica para definir el tratamiento adecuado según tus necesidades.',
  },
];

const Home: React.FC = () => {
  return (
    <div>
      <TituloPagina title="DentalPuente | Portada" />

      <main className="home-page content-wrap">
        <section className="home-hero-section">
          <div className="home-hero-copy">
            <span className="dp-eyebrow">Clínica dental en Guadalajara</span>
            <h1>Bienvenidos a DentalPuente</h1>
            <p>
              Cuidamos tu salud dental con atención profesional, trato humano y soluciones pensadas para que te sientas cómodo desde la primera visita.
            </p>
            <div className="home-hero-actions">
              <a className="dp-btn dp-btn-primary" href="/Contact">Agendar cita</a>
              <a className="dp-btn dp-btn-secondary" href="/About">Conoce al equipo</a>
            </div>
          </div>

          <div className="home-hero-visual">
            <img src={img01} alt="Consultorio DentalPuente" className="home-hero-image" />
            <div className="home-floating-card home-floating-card-top">
              <strong>Atención personalizada</strong>
              <span>Diagnóstico claro y acompañamiento.</span>
            </div>
            <div className="home-floating-card home-floating-card-bottom">
              <strong>Sonrisas saludables</strong>
              <span>Prevención, estética y ortodoncia.</span>
            </div>
          </div>
        </section>

        <section className="home-trust-grid" aria-label="Beneficios DentalPuente">
          <article className="home-trust-card">
            <span>01</span>
            <h3>Ética profesional</h3>
            <p>Tratamientos explicados de forma honesta y sin presión innecesaria.</p>
          </article>
          <article className="home-trust-card">
            <span>02</span>
            <h3>Calidad clínica</h3>
            <p>Atención ordenada, limpia y enfocada en resultados funcionales.</p>
          </article>
          <article className="home-trust-card">
            <span>03</span>
            <h3>Trato cercano</h3>
            <p>Un espacio amable para pacientes nuevos, familias y tratamientos de seguimiento.</p>
          </article>
        </section>

        <section className="home-mission-section">
          <div className="home-section-header">
            <span className="dp-eyebrow">Nuestra misión</span>
            <h2>Nuestra prioridad es ayudarte a mejorar tu sonrisa</h2>
            <p>
              Otorgar servicios de calidad para el cuidado dental, comprometidos con la ética profesional y enfocados en la satisfacción de nuestros pacientes.
            </p>
          </div>
          <div className="home-mission-panel">
            <div className="home-mission-item">
              <div className="home-mission-icon">✓</div>
              <div>
                <h3>Servicio profesional</h3>
                <p>Mantenemos altos estándares de calidad en cada tratamiento.</p>
              </div>
            </div>
            <div className="home-mission-item">
              <div className="home-mission-icon">♥</div>
              <div>
                <h3>Cuidado humano</h3>
                <p>Te explicamos tus opciones para que tomes decisiones con tranquilidad.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="home-services-section">
          <div className="home-section-header centered">
            <span className="dp-eyebrow">Servicios dentales</span>
            <h2>Tratamientos para cuidar tu sonrisa</h2>
            <p>Servicios esenciales para diagnóstico, prevención, estética y seguimiento dental.</p>
          </div>

          <div className="home-services-grid">
            {services.map((service) => (
              <article className="home-service-card" key={service.title}>
                <div className="home-service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="home-branches-section">
          <div className="home-section-header centered">
            <span className="dp-eyebrow">Nuestras sucursales</span>
            <h2>Ahora más cerca de ti</h2>
            <p>Seguimos creciendo para atenderte mejor en Guadalajara.</p>
          </div>

          <div className="home-branches-grid">
            <article className="home-branch-card home-branch-card-active">
              <div className="home-branch-badge">Sucursal actual</div>
              <h3>DentalPuente Teodomiro Manzano</h3>
              <p>Teodomiro Manzano 4365, Guadalajara, Jal.</p>
              <span>Atención con previa cita</span>
            </article>

            <article className="home-branch-card home-branch-card-soon">
              <div className="home-branch-badge">Próximamente</div>
              <h3>Nueva sucursal Plaza La Gigantera</h3>
              <p>Estamos preparando un nuevo espacio DentalPuente para recibirte pronto.</p>
              <span>Apertura próximamente</span>
            </article>
          </div>
        </section>

        <section className="home-cta-section">
          <div>
            <span className="dp-eyebrow">¿Listo para tu cita?</span>
            <h2>Agenda tu valoración dental</h2>
            <p>Contáctanos por WhatsApp y resolvemos tus dudas antes de visitarnos.</p>
          </div>
          <a className="dp-btn dp-btn-primary" href="/Contact">Solicitar cita</a>
        </section>
      </main>
    </div>
  );
};

export default Home;
